import React, { memo } from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import styles from './FlatTreeChevron.module.scss';

interface IFlatTreeChevronProps {
	toggleCollapse: () => void;
	isCollapsed: boolean;
	testName?: string;
}

export const FlatTreeChevron = ({
	toggleCollapse,
	isCollapsed,
	testName,
}: IFlatTreeChevronProps) => {
	const chevronClasses = cn(styles.chevron, {
		[styles.collapsed]: isCollapsed,
	});

	return (
		<span
			className={chevronClasses}
			data-testid={`${isCollapsed ? 'collapsed' : 'expanded'}_chevron_${testName}`}
			onClick={toggleCollapse}
		>
			{Icons.chevronDown()}
		</span>
	);
};

export default memo(FlatTreeChevron);
